// iter87.508 (user-provided) — MLS club brand color pairs [primary,
// secondary]. Keyed by the name this app displays, plus common
// vendor/alias forms (with/without "FC"/"SC" suffix, short names) so
// this stays correct regardless of which exact string API-Football
// returns. Previously MLS/Playoffs team swatches fell through
// `sport="soccer"` (EPL/La Liga lookup only) to the generic gray
// fallback — every MLS club now gets its real colors.
export const MLS_TEAM_COLORS = {
    "Atlanta United": ["#A32035", "#2D2A26"],
    "Atlanta United FC": ["#A32035", "#2D2A26"],
    "Austin FC": ["#00B140", "#000000"],
    "Austin": ["#00B140", "#000000"],
    "Charlotte FC": ["#0085CA", "#000000"],
    "Charlotte": ["#0085CA", "#000000"],
    "Chicago Fire": ["#FF0000", "#141946"],
    "Chicago Fire FC": ["#FF0000", "#141946"],
    "FC Cincinnati": ["#FE5000", "#003087"],
    "Cincinnati": ["#FE5000", "#003087"],
    "Columbus Crew": ["#FEDD00", "#000000"],
    "Columbus Crew SC": ["#FEDD00", "#000000"],
    "D.C. United": ["#EB0029", "#2E2A25"],
    "DC United": ["#EB0029", "#2E2A25"],
    "Inter Miami CF": ["#F7B5CD", "#231F20"],
    "Inter Miami": ["#F7B5CD", "#231F20"],
    "Inter Miami FC": ["#F7B5CD", "#231F20"],
    "CF Montréal": ["#003DA6", "#000000"],
    "CF Montreal": ["#003DA6", "#000000"],
    "Montreal Impact": ["#003DA6", "#000000"],
    "Nashville SC": ["#ECE83A", "#1F1646"],
    "Nashville": ["#ECE83A", "#1F1646"],
    "New England Revolution": ["#0A2240", "#CE0E2D"],
    "New England": ["#0A2240", "#CE0E2D"],
    "New York City FC": ["#9FD2FF", "#000229"],
    "NYCFC": ["#9FD2FF", "#000229"],
    "New York City": ["#9FD2FF", "#000229"],
    "New York Red Bulls": ["#B91F31", "#FFC72C"],
    "NY Red Bulls": ["#B91F31", "#FFC72C"],
    "Red Bulls": ["#B91F31", "#FFC72C"],
    "Orlando City SC": ["#60269E", "#F0D283"],
    "Orlando City": ["#60269E", "#F0D283"],
    "Philadelphia Union": ["#051C2C", "#E0D0A6"],
    "Philadelphia": ["#051C2C", "#E0D0A6"],
    "Toronto FC": ["#AA182C", "#323E48"],
    "Toronto": ["#AA182C", "#323E48"],
    "Colorado Rapids": ["#8A2432", "#8AB7E9"],
    "Colorado": ["#8A2432", "#8AB7E9"],
    "FC Dallas": ["#C6093B", "#001F5B"],
    "Dallas": ["#C6093B", "#001F5B"],
    "Houston Dynamo": ["#FF6B00", "#101820"],
    "Houston Dynamo FC": ["#FF6B00", "#101820"],
    "Houston": ["#FF6B00", "#101820"],
    "LA Galaxy": ["#15284B", "#FFCE00"],
    "Los Angeles Galaxy": ["#15284B", "#FFCE00"],
    "LAFC": ["#010101", "#C39F6C"],
    "Los Angeles FC": ["#010101", "#C39F6C"],
    "Minnesota United": ["#231F20", "#9BCDE4"],
    "Minnesota United FC": ["#231F20", "#9BCDE4"],
    "Minnesota": ["#231F20", "#9BCDE4"],
    "Portland Timbers": ["#2C5234", "#C99700"],
    "Real Salt Lake": ["#A50531", "#001E61"],
    "RSL": ["#A50531", "#001E61"],
    "San Jose Earthquakes": ["#0067B1", "#000000"],
    "San Jose": ["#0067B1", "#000000"],
    "Seattle Sounders": ["#4FB84F", "#0033A1"],
    "Seattle Sounders FC": ["#4FB84F", "#0033A1"],
    "Seattle": ["#4FB84F", "#0033A1"],
    "Sporting Kansas City": ["#A7C6ED", "#0C2340"],
    "Sporting KC": ["#A7C6ED", "#0C2340"],
    "St. Louis City SC": ["#EC1458", "#001544"],
    "St. Louis City": ["#EC1458", "#001544"],
    "St Louis City SC": ["#EC1458", "#001544"],
    "Vancouver Whitecaps": ["#12284C", "#8AB7E9"],
    "Vancouver Whitecaps FC": ["#12284C", "#8AB7E9"],
};

function hashColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) % 360;
    }
    return `hsl(${hash}, 55%, 38%)`;
}

// Returns [primary, secondary] — real brand pair when known, otherwise
// a deterministic single-hue fallback so an unmapped name still renders.
export function mlsTeamColorPair(name) {
    return MLS_TEAM_COLORS[name] || [hashColor(name), hashColor(name)];
}
